const prepareAreaString = (area, type, unit) => {
  if (area.enableLabel) {
    return area.label;
  } else if (!area.enableLabel && area[type].min[unit] < area[type].max[unit]) {
    return (
      area[type].min[unit] +
      " Sq" +
      unit +
      "." +
      " to " +
      area[type].max[unit] +
      " Sq" +
      unit +
      "."
    );
  } else if (
    !area.enableLabel &&
    area[type].min[unit] === area[type].max[unit]
  ) {
    return area[type].min[unit] + " Sq" + unit + ".";
  } else if (!area.enableLabel && area[type].min[unit] > area[type].max[unit]) {
    return area[type].min[unit] + " Sq" + unit + ". onwards";
  }
};

export default prepareAreaString;
